import DataTable from "react-data-table-component"
import DataTableExtensions from 'react-data-table-component-extensions'
import "react-data-table-component-extensions/dist/index.css"
import { useTranslation } from "react-i18next"

export const CustomDataTable = (props) => {
    const { t } = useTranslation()

    const {columns, data, defaultSortField = "id", defaultSortAsc = false, expandedData} = props

    const tableData = {
        columns: columns,
        data: data,
        exportHeaders: true,
        print: false,
        export: false,
        filterPlaceholder: t('datatables.buscar') 
    }

    return (
        <>
            <DataTableExtensions {...tableData}>
                <DataTable
                    className="table table-sm table-striped table-bordered table-hover customtable"
                    noDataComponent={t('datatables.sinresultados')}
                    labelRowsPerPage={t('datatables.elementosporpagina')}
                    defaultSortField={defaultSortField}
                    defaultSortFieldId={defaultSortField}
                    defaultSortAsc={defaultSortAsc}
                    expandableRows={!!expandedData}
                    expandableRowsComponent={expandedData ? expandedData : undefined}
                    pagination
                    paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                    paginationPerPage = {50}
                    paginationComponentOptions={{ 
                        rowsPerPageText: t('datatables.elementosporpagina'),
                        rangeSeparatorText: t('datatables.de'),
                        noRowsPerPage: false,
                        selectAllRowsItem: true,
                        selectAllRowsItemText: t('datatables.todos')
                    }}
                />
            </DataTableExtensions>
        </>
  )
}